import axios from "axios";
import { showError } from "./components/alerts";

const API = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL, 
  headers: {
    "Content-Type": "application/x-www-form-urlencoded",
  },
});

// API.interceptors.request.use(
//   (config) => {
//     const token = localStorage.getItem("token");
//     if (token) {
//       config.headers.Authorization = `Bearer ${token}`;
//     }
//     return config;
//   },
//   (error) => {
//     return Promise.reject(error);
//   }
// );

API.interceptors.response.use(
  (response) => response.data,
  (error) => {
    let message = "Something went wrong!";
    
    if (error.response) {
      message = error.response.data?.message || message;
      if (error.response.status === 401) {
        localStorage.removeItem("token");
        window.location.href = "/login";  
      }
    } else if (error.request) {
      message = "No response from server. Please try again.";
    }

    showError(message);

    return Promise.reject(error);
  }
);

export default API;
